<div class="main-wrapper">
<router-outlet></router-outlet>
<app-loading-spinner *ngIf="loadingSpninerHide"></app-loading-spinner>
</div>
